<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Informasi
                </h1>
            </div>
            <form @submit.prevent="store">
                <FlashMessage class="mt-5 mb-5"/>
                <textarea class="w-full border-2 border-solid border-black p-2" v-model="form.informasi" rows="5" cols="50"></textarea>
                <div class="w-full flex justify-center">
                    <button
                        type="submit"
                        class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 text-white m-auto w-1/2"
                    >
                        Simpan
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
export default {
    components: {
        Link,
        RandomShape,
        FlashMessage
    },
    data() {
        return {
            form: this.$inertia.form({
                informasi: this.informasi
            }),
        };
    },
    props: {
        informasi: String,
    },
    methods: {
        store(){
            const confirm = window.confirm(
                "Yakin Anda akan menyimpan informasi tersebut?"
            );
            if (confirm == 1) {
                this.form.post("/admin/informasi", { preserveScroll: true });
            }
        }
    },
    layout: LayoutAdmin,
};
</script>
